import React from 'react';
import SocialTrackerComponent from '@/components/social-tracker/SocialTracker';
import { SubscriptionGuard } from '@/components/ui/subscription-guard';

const SocialTracker: React.FC = () => {
  return (
    <SubscriptionGuard feature="social_tracker">
      <SocialTrackerComponent />
    </SubscriptionGuard>
  );
};

export default SocialTracker;
